import React, { useRef } from 'react'
import VoyageRow from '../voyages/VoyageRow'
import { useEffect } from 'react'
import { fetchEuaDistribution, fetchVoyageEuaOverview, fetchVoyages, fetchVoyagesHistory } from '../../features/Voyage/VoyageSlice'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { clearVoyages, searchVoyages } from '../../features/Voyage/VoyageSlice'
import Search from '../../components/Search'
import { DatePicker, Input } from 'antd'
import format from 'date-fns/format'
import Papa from 'papaparse';
import { selectVoyage } from '../../features/Voyage/VoyageSlice'
import SkeltonTable from '../../components/SkeltonTable'
import Clipboard from "../../assets/icons/voyages/clipboard-import.svg"
import { useLocation } from 'react-router-dom';
import { fetchCSVDocumentforVessels } from '../../features/EUA/EuaSlice'

const { RangePicker } = DatePicker
const Voyage = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const scrollableArea = useRef(null)
  const { voyages, status, page, selectedVoyage } = useSelector((state) => state.voyage);
  const [updatedPage, setUpdatedPage] = useState(page)
  const { csvDocument } = useSelector((state) => state.eua)
  const [customDate, setCutomDate] = useState(null)

  const DateChangeHandler = (date) => {
    setCutomDate(date)
    if (date !== null) {
      const temp = {
        start_date: format(new Date(date[0]), "yyyy-MM-dd"),
        end_date: format(new Date(date[1]), "yyyy-MM-dd"),
        imo_number: selectedVoyage?.imo_number
      }
      dispatch(fetchCSVDocumentforVessels(temp))
    }
  }

  const downloadCsv = () => {
    const rearrangedData = [];
    let prevVesselName = '';

    csvDocument.forEach((row) => {
      const { vessel_name, ...rest } = row;

      if (!vessel_name || vessel_name === prevVesselName) {
        rearrangedData.push({ vessel_name: '', ...rest });
      } else {
        rearrangedData.push({ vessel_name, ...rest });
        prevVesselName = vessel_name;
      }

    });

    const result = rearrangedData.map((originalData, key) => {
      return {
        "IMO Number": originalData.imo_number,
        "Vessel Name": originalData.vessel_name,
        "Owner": originalData.active_owner,
        "Casper ID": originalData.casper_id,
        "Start Date": originalData.min_as_of_date_voyage_data,
        "End Date": originalData.max_as_of_date_voyage_data,
        "Start Port": originalData.start_port,
        "End Port": originalData.end_port,
        "EU Identifier": originalData.eu_identifier,
        "AER": originalData?.cii?.toFixed(3),
        "CII": originalData.technical_grade,
        "CO2 Eq ETS (MT)": originalData?.co2eq_emissions_ets?.toFixed(3),
        "EUA Due": originalData?.eua_due?.toFixed(3),


        // "GHG Intensity": originalData?.total_ghg?.toFixed(3),
        // "Compliance Balance": originalData?.compliance_balance?.toFixed(3),
        // "Penalty": originalData?.penalty?.toFixed(3),
        // "TTW": originalData?.ttw?.toFixed(3),
      }
    })
    const csv = Papa.unparse(result);
    const blob = new Blob([csv], { type: 'text/csv' });

    const link = document.createElement('a');

    link.href = URL.createObjectURL(blob);
    link.download = 'data.csv';
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  };

  const getVoyagesData = () => {
    if (status !== "loading") {
      const payload = {
        page: page,
        casper_id: '',
        requested_tab: ''
      }
      dispatch(fetchVoyages(payload)).then((result) => {
        if (page === 1 && result.payload) {
          dispatch(selectVoyage(result.payload[0]))
        }
      });
    }
  }

  // useEffect(() => {
  //   dispatch(fetchVoyages(1))
  // }, []);

  useEffect(() => {
    if (voyages.length === 0)
      getVoyagesData()
  }, [updatedPage]);

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } =
      scrollableArea.current;
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setUpdatedPage(updatedPage + 1)
      getVoyagesData()
    }
  }



  const selectVoyageHanlder = (voyage) => {
    setCutomDate(null)
    if (voyage.casper_id === selectedVoyage.casper_id) {
      return
    }
    // console.log(voyage)
    console.log(voyages)
    dispatch(selectVoyage(voyage))
  }

  const clearSearchHandler = async (setValue) => {
    setValue(null)
    dispatch(clearVoyages())
    const params = {
      casper_id: '',
      requested_tab: '',
      page: 1
    }
   const result = await dispatch(fetchVoyages(params));

    if (result.payload && result.payload.length > 0) {
      dispatch(selectVoyage(result.payload[0]));
    }
  }

  const searchHandler = async (record, setOpen, setValue) => {
      setValue(record.vessel_name);
      const params = {
        vessel_name: record.vessel_name,
        voyage_number: record.voyage_number || null, // Ensure to handle undefined keys
        imo_number: record.imo_number,
        casper_id: record.casper_id,
        requested_tab: '',
        page: 1
      };
      
      // console.log("Matching Voyage:", record);
      setOpen(false);
      dispatch(clearVoyages())
      const result = await dispatch(fetchVoyages(params));
      if (result.payload && result.payload.length > 0) {
        dispatch(selectVoyage(result.payload[0])); 
      }
  };
  

  useEffect(() => {
    dispatch(clearVoyages())
    setUpdatedPage(1)
  }, [location.pathname]);


  return (
    <div className="card voyage-table-card">
      <div className="vessel-card-filter" style={{ padding: "1%", margin: "0" }}>
        <div style={{ width: "50%" }}>
          <Search onClear={clearSearchHandler} onSelect={searchHandler} />
        </div>
        <div className='vessel-card-report-download'>
          {/* <DatePicker size='large' onChange={onChange} /> */}
          <RangePicker getPopupContainer={(trigger) => trigger.parentNode} format="YYYY-MM-DD" value={customDate} style={{ width: 250 }} onChange={DateChangeHandler} />
          {csvDocument !== null && customDate !== null ?
            <div onClick={downloadCsv} style={{ display: "flex", flexDirection: "column" }}>
              <img src={Clipboard} style={{ height: "25px", cursor: "pointer" }} alt="" />
              {/* <span className='card-icon-span'>{"Download Report"}</span> */}
            </div> : ""
          }
        </div>
      </div>
      <div className='vessel-card-table' onScroll={handleScroll} ref={scrollableArea}>
        {voyages.length === 0 ? <SkeltonTable /> :
          voyages.map((voyage, index) => (
            <VoyageRow key={index} onSelect={() => selectVoyageHanlder(voyage)} voyage={selectedVoyage?.imo_number === voyage?.imo_number ? selectedVoyage : voyage} />
          ))}
      </div>
    </div>
  )
}

export default Voyage